import axios from "axios";

export const baseURLLocal = "https://api.wocons.com:8443/api/";

const API = axios.create({
    baseURL: baseURLLocal,
    headers: {
        "Content-Type": "application/json",
    },
});

API.interceptors.request.use((config) => {

    const token = sessionStorage.getItem("token");

    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
});

export const createEnquiry = async (data) => {
    const response = await API.post("Enquiry/create", data);
    return response.data;
};

